import { useFormikContext } from "formik";
import { TextEditor, TextEditorProps } from "../components";
import { BaseInputProps } from "./FormField";
import { get } from "lodash";

export type FormTextEditorProps = TextEditorProps;

function FormTextEditor({
  name,
  placeholder,
}: FormTextEditorProps & Pick<BaseInputProps, "name">) {
  const { setFieldValue, values } = useFormikContext();
  return (
    <TextEditor
      value={get(values, name, "")}
      placeholder={placeholder}
      onChange={(data) => {
        setFieldValue(name, data);
      }}
    />
  );
}

export default FormTextEditor;
